import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext'; // 🔐 Added this
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error("Failed to find the root element. Check your index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {/* 🌍 The AuthProvider wraps everything so the "Global Memory" works */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);